<template>
  <transition name="forward">
  <div class="wrapper">
    <div class="billbody">
      <scroller>
        <div style="width: 90%;margin: 10px auto;color: white;text-align: center" v-if="billOrder.length === 0">未检测到任何账单信息</div>
        <div class="card" v-for="bill in billOrder">
          <div class="flex-row title font1">
            <div class="flex1 text-left">提货单号：
              <span v-if="!bill.offlineno">尚未生成</span>
              <span v-if="bill.offlineno">{{bill.offlineno}}</span>

            </div>
            <div class="flex1 text-right" v-if="bill.orderType<2&&bill.orderState==1" @click="getQrcode(bill)">
              <img  src="../../assets/image/qrcode.svg" width="26" style="vertical-align: middle">
              提货二维码
            </div>
            <div class="flex1 text-right" v-if="bill.orderType>=2||bill.orderState!=1" >
              <img   src="../../assets/image/qrcode2.svg" width="26" style="vertical-align: middle">
              提货二维码
            </div>
          </div>
          <bg-yun>
            <div class="flex-row font-0-8 padding-10">
              <div class="flex2 text-left color-gray ">{{bill.date}}</div>
              <div class="flex1 text-right color-yellow" v-if="bill.orderType===0"> 堂食</div>
              <div class="flex1 text-right color-yellow" v-if="bill.orderType===1"> 外带</div>
              <div class="flex1 text-right color-yellow" v-if="bill.orderType===2"> 外卖</div>
            </div>

            <div class=" font-0-7 color-gray" style="padding: 0 10px">订单处理详情:<span v-html="bill.offlineLog"></span></div>

            <!-- 外卖配送信息 -->
            <div class="sub-title color-black" v-if="bill.orderType===2 && bill.takeoutInfo">
              <div class="flex-row font-0-8 padding-10" style="border-bottom: 1px solid #f2e4cf">
                <div class="text-left ">配送状态：</div>
                <div v-if="bill.orderState==1" class="color-yellow flex4 text-left">
                  商家未接单
                </div>
                <div v-if="bill.orderState==2" class="color-yellow flex4 text-left" >
                  <span v-if="bill.takeoutInfo.dispatchType=='0'">商家已接单(门店自配送)</span>
                  <span v-else>
                    <span v-if="bill.takeoutInfo.deliveryState==0 || bill.takeoutInfo.deliveryState==1" class="magin-l-6">商家已接单,骑手正赶往门店</span>
                    <span v-if="bill.takeoutInfo.dispatchId && bill.takeoutInfo.deliveryState==2" class="magin-l-6 color-blue" @click="showDispatchDtl(bill)">正在配送中 [查看骑手位置]</span>
                    <span v-if="bill.takeoutInfo.dispatchId && bill.takeoutInfo.deliveryState==3" class="magin-l-6 " >配送已完成</span>
                    <span v-if="bill.takeoutInfo.dispatchId && bill.takeoutInfo.deliveryState==4" class="magin-l-6 " >配送已取消</span>
                  </span>
                </div>
                <div v-if="bill.orderState==3 || bill.orderState==3 " class="color-yellow flex4 text-left">
                  已取消
                </div>
              </div>
              <div class="flex-row font-0-8 padding-10" style="border-bottom: 1px solid #f2e4cf">
                <div class="flex1 text-left "> 收货人：{{bill.takeoutInfo.customerName}}</div>
                <div class="flex text-left ">联系电话：
                  <a :href="'tel:' + bill.takeoutInfo.customerTel">{{bill.takeoutInfo.customerTel}}</a>
                </div>
              </div>
              <div class="flex-row font-0-8 padding-10" style="border-bottom: 1px solid #f2e4cf">
                <div class="text-left ">配送地址：</div>
                <div class="color-yellow flex4 text-left">{{bill.takeoutInfo.customerAddr}}</div>
              </div>

              <div  v-if="bill.otherFee>0 && bill.orderType===2" class="flex-row font-0-8 padding-10" style="border-bottom: 1px solid #f2e4cf">
                <div class="flex1 text-left ">配送费：<span class="color-yellow">{{bill.otherFee}}元</span></div>
                <div class="flex1 text-left "></div>
              </div>

              <div  v-if="bill.otherFee===0 && bill.orderType===2" class="flex-row font-0-8 padding-10" style="border-bottom: 1px solid #f2e4cf">
                <div class="flex1 text-left ">配送费：<span class="color-yellow">{{bill.otherFee_t}}</span></div>
                <div class="flex1 text-left "></div>
              </div>

            </div>


            <!-- 订单头概览 -->
            <div class="sub-title color-black">
              <div class="flex-row font-0-8 padding-10" style="border-bottom: 1px solid #f2e4cf">
                <div class="flex1 text-left ">订单金额：</div>
                <div class="flex1 text-left ">{{bill.orderAmount}}元</div>
                <div class="flex1 text-left "> 实付金额:</div>
                <div class="flex1 text-left "><span class="color-yellow">{{bill.realFee}}元</span></div>
              </div>

              <div  v-if="bill.memo" class="flex-row font-0-8 padding-10" style="border-bottom: 1px solid #f2e4cf">
                <div>订单备注：</div>
                <div class="flex1 text-left "><span class="color-yellow" v-html="bill.memo"></span></div>
              </div>

              <div class="flex-row font-0-8 padding-10" style="border-bottom: 1px solid #f2e4cf">
                <div class="flex1 text-left "> 支付方式:&nbsp;&nbsp;{{bill.payDesc}}</div>
              </div>
              <!--<div class="flex-row font-0-8 padding-10" style="border-bottom: 1px solid #f2e4cf">-->
                <!--<div class="flex1 text-left "> 订单凭证：{{bill.dailyid}}</div>-->
              <!--</div>-->
              <div class="flex-row font-0-8 padding-10">
                <div class="flex1 text-left "> 门店名称： <span v-if="bill.storeInfo.storeName">{{bill.storeInfo.storeName}}</span></div>
              </div>
              <div class="flex-row font-0-8 padding-10">
                <div class="text-left ">门店电话：</div>
                <div class="color-yellow flex4 text-left">
                  <a :href="'tel:' + bill.storeInfo.storeTel">{{bill.storeInfo.storeTel}}</a>
                </div>
              </div>
            </div>

            <div class="padding-10 color-gray font-0-8">订单详情</div>
            <div class="padding-5" v-for="foodType in  bill.orderDetail">
              <div v-if="foodType.isGroup == 0">
                <div class="type padding-5 text-center font-0-8">{{foodType.name}}:{{foodType.menuItem.length}}道</div>
                <div class="order color-black" v-for="food in foodType.menuItem">
                  <div class="flex-row font-0-8 padding-10 order-name">
                    <div class=" text-left ">{{food.num}}</div>
                    <div class="color-gray font-1-4 flex1 text-center">×</div>
                    <div class=" flex4 text-left "> {{food.name}}&nbsp;<span v-if="food.memo" class="color-yellow">[{{food.memo.toString()}}]</span></div>
                    <div class="flex2 text-right ">{{(food.price*1).toFixed(2)}}元/{{food.standard}}</div>
                  </div>
                  <div class="flex-row font-0-8 padding-5 bg-white color-gray" v-for="remarkFood in food.menuItem "
                       style="border-bottom: 1px solid #f2f2f2">
                    <div class="flex1 text-right ">{{remarkFood.num}}&nbsp;&nbsp;X</div>
                    <div class="flex4 text-left magin-l-6"> {{remarkFood.name}}</div>
                    <div class="flex2 text-right ">{{(remarkFood.price).toFixed(2)}}元 /{{remarkFood.standard}}</div>
                  </div>
                </div>
              </div>
              <div v-if="foodType.isGroup == 1">
                <div class="type padding-5 text-center font-0-8">套餐:{{foodType.menuItem.length}}道</div>
                <div class="order color-black" v-for="food in foodType.menuItem">
                  <div class="flex-row font-0-8 padding-10 order-name">
                    <div class=" text-left ">{{food.num}}</div>
                    <div class="color-gray font-1-4 flex1 text-center">×</div>
                    <div class=" flex4 text-left "> {{food.name}}&nbsp;<span v-if="food.memo"  class="color-yellow">[{{food.memo.toString()}}]</span></div>
                    <div class="flex2 text-right ">{{(food.price*1).toFixed(2)}}元/套</div>
                  </div>
                  <div class="flex-row font-0-8 padding-5 bg-white color-gray" v-for="suiteitem in food.menuItem "
                       style="border-bottom: 1px solid #f2f2f2">
                    <div class="flex1 text-right ">{{suiteitem.num}}&nbsp;&nbsp;X</div>
                    <div class="flex4 text-left magin-l-6"> {{suiteitem.name}}<span v-if="suiteitem.memo"  class="color-yellow">[{{suiteitem.memo.toString()}}]</span></div>
                  </div>
                </div>
              </div>
            </div>
          </bg-yun>
        </div>
        <div style="height: 10px;"></div>
      </scroller>
    </div>

    <div class="footer3 color-white font-0-8 text-center flex-row">
      <div class="footer-item bg-blue" @click.stop="clickBack()">
        <img class="margin-b-3" src="../../assets/image/arrow-left.png" width="20" style="vertical-align: middle">返回
      </div>
      <div class="footer-item flex1"> </div>
      <div class="footer-item bg-gray-yellow" @click.stop="clickFresh()">刷新</div>
    </div>
    <delivery ref="delivery" :dispatch-id="c_dispatchid" :storeInfo="c_storeInfo"></delivery>
  </div>
  </transition>

</template>

<script>
  import ServiceUtils from "../../service/ServiceUtils";
  import bgyun from "../bg-yun/bgyun";
  import ServiceHttp from "../../service/ServiceHttp";
  import ServiceDialog from "../../service/ServiceDialog";
  import Delivery from "../deliveryDetail/qishou"

  export default {
    name: "bill",
    data(){
      return{
          billOrder:[],
          c_dispatchid:"",
          c_storeInfo:{tel:""}
      }
    },
    components:{
      'bg-yun':bgyun,
      Delivery
    },

    methods:{
      showDispatchDtl(bill){
        this.c_dispatchid = bill.takeoutInfo.dispatchId;
        this.c_storeInfo.tel = bill.takeoutInfo.serviceTel;
        setTimeout(()=>{
            this.$refs.delivery.startInterval();
        },100);
      },
      getQrcode(billItem){
        ServiceHttp.getQrcode(billItem.outtradeno,function(res){
          let imgurl = "data:image/png;base64,"+res;
          let url ='<img src="'+imgurl+'" width="200">'
          ServiceDialog.showAlert('提货二维码',url);
        });
      },
      /**
       * 点击返回
       * */
      clickBack(){
        let url = ""
        if(ServiceUtils.menuData.length>0){
          url = '/order/{0}/{1}/{2}/{3}'.format(ServiceUtils.config.sellerId,ServiceUtils.config.storeId,ServiceUtils.config.orderType,1);
        }else {
          url = '/choose/{0}'.format(ServiceUtils.config.sellerId);
        }
        this.$router.replace({path:url});
      },
      /**
       * 刷新
       * */
      clickFresh(){
        this.getBill();
      },
      /**
       * 获取已结账单
       */
      getBill() {
        ServiceHttp.getBill((bills)=>{
          console.log('获取已结账单:',bills);

          bills.forEach(function(b) {
            // var d = new Date(b.createTime);
            // b.date = d.format("yyyy-MM-dd EE HH:mm");
            b.date = b.createTime;
            if(b.memo){
              b.memo=b.memo.replace(/\r\n/g,'<br/>');
            }
            console.log(b);
            b.payDesc = "";
            if (Array.isArray(b.payInfos)) {
              for (var o = 0; o < b.payInfos.length; ++o) {
                b.payDesc += b.payInfos[o].code + ":" + b.payInfos[o].destamount + "元 ";
              }
            }
            // b.offlineLog = $sce.trustAsHtml(b.offlineLog);
            b.orderAmount = Number(b.orderAmount) / 100;
            b.realFee = Number(b.realFee) / 100;
            b.otherFee = Number(b.otherFee) /100;
            if (b.otherFee === 0 || b.otherFee === '0') {
              b.otherFee_t = "免费";
            } else {
              b.otherFee = Number(b.otherFee);
            }
          });
          this.billOrder.length = 0;
          this.billOrder.append(bills);

          // if(this.billOrder.length == 0){
          //   ServiceDialog.showAlert('温馨提示','未检测到任何账单信息')
          // }

        });
      },
    },
    mounted() {
      let params = this.$route.params ;      //url参数
      ServiceUtils.config.sellerId = params.sellerId;
      this.getBill();
    },

  }
</script>

<style scoped lang="scss">
  @import "../../assets/css/style";
  .color-white{color:#ffffff}
  .wrapper{position: fixed;top: 0;right: 0;left: 0;bottom: 0;z-index: 99;background-color: #7B6E52;}
  .footer3{position: fixed;padding: 4px 6px;right: 0;left: 0;bottom: 0;background-color: #000;display: flex;justify-content:space-around;align-items: center;}
  .footer-item{height: 42px;width: 23%;border-radius: 3px;vertical-align: middle;line-height: 42px;}
  .bg-gray-yellow{background:#CEB66B}
  .bg-blue{background:#00ABF8}
  .bg-footer-yellow{background-color: #FF6D00}
  .margin-b-3{ margin-bottom: 3px; }
  .margin-b-2{ margin-bottom: 2px; }
  a{ color: #FF6D00}
  .font-0-7{font-size: 0.7em;}
  .font-0-8{font-size: 0.8em;}
  .font-0-9{font-size: 0.9em;}
  .billbody{
    position: fixed;top: 0;right: 0;left: 0;bottom: 52px;margin-bottom: 5px;
  }
  .card{
    margin: 8px 4px 0 4px;
    overflow: hidden;
    border-radius: 8px;

  }
  .card>.title{
    background-color: #E3C78A;
    padding: 16px;
  }
  .sub-title{
    margin: 5px;
    border-radius: 5px;
    background-color: #F6F3E8;
  }
  .type{
    background-color: #F6F3E8;
    /*border: 1px solid #dddddd;*/
    border-radius: 5px;
  }
  .order{
    margin-top: 5px;
    border-radius: 5px;
  }
  .order-name{
    background-color: #F6F3E8;
  }

</style>



// WEBPACK FOOTER //
// src/components/routerPages/bill.vue